import React, { useState } from "react";
import usePWAInstall from "../usePWAInstall";
import Localize from "../../Localize/Localize";
import LocalizeKeys from "../../Localize/LocalizeKeys";
import UserAgent from "../../Utils/UserAgent";
import "../install-banner.css";
import RemoteConfigService from "../../RemoteConfigService";

const APP_STORE_URL = "https://apps.apple.com/app/mundijuegos-cash/id6526485442";

const renderOpenInBrowserBanner = (setDismissed) => (
    <div className="pwa-banner">
        <div className="pwa-banner__help">
            <p>{Localize.translateByBrowserOrFallback(LocalizeKeys.INSTALL_IOS_EXTERNAL_BROWSER)}</p>
        </div>
        <button className="pwa-banner__close" onClick={() => setDismissed(true)}>
            ×
        </button>
    </div>
);

const renderAppStoreBanner = (handleAppStoreClick, setDismissed) => (
    <div className="pwa-banner">
        <div className="pwa-banner__content">
            <div className="pwa-banner__text">
                {Localize.translate(LocalizeKeys.INSTALL_APP)}
            </div>
            <button className="pwa-banner__btn" onClick={handleAppStoreClick}>
                {Localize.translate(LocalizeKeys.INSTALL_APPSTORE)}
            </button>
        </div>
        <button className="pwa-banner__close" onClick={() => setDismissed(true)}>
            ×
        </button>
    </div>
);

const renderManualInstallBanner = (setDismissed) => (
    <div className="pwa-banner">
        <div className="pwa-banner__help">
            <p>{Localize.translateAndFormat(LocalizeKeys.INSTALL_IOS_SHARE)}</p>
        </div>
        <button className="pwa-banner__close" onClick={() => setDismissed(true)}>
            ×
        </button>
    </div>
);

const IOSInstallBanner = () => {
    const {canInstall, promptInstall, isStandalone, supportsManualAddToHome, countryCode,} = usePWAInstall();

    const [dismissed, setDismissed] = useState(false);

    const allowedCountries = RemoteConfigService.getToastAppStoreCountries() || [];
    const shouldOpenAppStore = allowedCountries.includes(countryCode?.toLowerCase());

    const openInExternalBrowser = !canInstall && !isStandalone && UserAgent.isEmbeddedWebView();

    console.log("[PWA] IOSInstallBanner, OpenAppStore:", shouldOpenAppStore,
        ", canInstall: ", canInstall, "supportsManualAddToHome: ", supportsManualAddToHome,
        "openInExternalBrowser:", openInExternalBrowser, "isStandalone:", isStandalone, "UserAgent.isEmbeddedWebView()", UserAgent.isEmbeddedWebView());

    if (
        dismissed ||
        (isStandalone && !shouldOpenAppStore && !supportsManualAddToHome) ||
        (!shouldOpenAppStore && !supportsManualAddToHome && !openInExternalBrowser)
    ) {
        return null;
    }

    const handleAppStoreClick = async () => {
        window.open(APP_STORE_URL, "_blank", "noopener,noreferrer");
        setDismissed(true);
    };

    if (openInExternalBrowser && RemoteConfigService.getLandingConfigValue("ToastOpenExternalBrowser"))
        return renderOpenInBrowserBanner(setDismissed);

    if (shouldOpenAppStore && RemoteConfigService.getLandingConfigValue("ToastInstallAppStore"))
        return renderAppStoreBanner(handleAppStoreClick, setDismissed);

    if (supportsManualAddToHome && RemoteConfigService.getLandingConfigValue("ToastAddFavorites"))
        return renderManualInstallBanner(setDismissed);

    return null;
};

export default IOSInstallBanner;
